import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import ProviderList from '@apps/shared/src/providerSearch/providerList/ProviderList';
import AppLayout from '../shared/AppLayout';
import PageSpecificHeader from '../shared/PageSpecificHeader';
import { contentHeight } from '../shared/theme';
import { getPlans, getAllPlansForMedivi } from './actions';
import ProviderSearchFilterPane from './ProviderSearchFilterPane';
import { RootState } from '../store';

const Container = styled(Box)({
  width: '100%',
  display: 'flex',
  height: `calc(${contentHeight} - 6vh - 0.5rem)`,
});

const mapStateToProps = ({ providerSearch, user }: RootState): StateProps => ({
  selectedZipCode: providerSearch.selectedZipCode,
  filteredCount: providerSearch.filteredList.length || 0,
  fullCount: providerSearch.fullList.length || 0,
  has6dhallplansRole: user.currentUser?.roles?.includes('medivi-6dhallplans') ?? false,
});

const mapDispatchToProps = {
  getPlans,
  getAllPlansForMedivi,
};

type StateProps = {
  selectedZipCode: string;
  filteredCount: number;
  fullCount: number;
  has6dhallplansRole: boolean;
};

type Props = StateProps & typeof mapDispatchToProps;

export function ProviderSearch({
  filteredCount,
  fullCount,
  selectedZipCode,
  has6dhallplansRole,
  getPlans,
  getAllPlansForMedivi,
}: Props): JSX.Element {
  useEffect(() => {
    if (has6dhallplansRole) {
      getAllPlansForMedivi();
    } else {
      getPlans();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [has6dhallplansRole]);

  return (
    <AppLayout>
      {!selectedZipCode && (
        <PageSpecificHeader
          title="Provider Search"
          description="Enter Zip code to search for providers nearby you"
        />
      )}
      {selectedZipCode && (
        <PageSpecificHeader
          title="Provider Search"
          description="Search for Providers by zip code"
        />
      )}
      <Container>
        <ProviderSearchFilterPane />

        {/* for selenium testing */}
        <p id="provider-filtered-count" style={{ visibility: 'hidden', width: '0' }}>
          {`filtered: ${filteredCount}`}
        </p>
        <p id="provider-full-count" style={{ visibility: 'hidden', width: '0' }}>
          {`full: ${fullCount}`}
        </p>
        {/* end test section */}

        <ProviderList />
      </Container>
    </AppLayout>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ProviderSearch);
